import React, { useEffect, useState } from "react";
// import { Card, CardContent, Box, Button, Tabs, Tab } from "@mui/material";
import * as services from "./../../services/customer";
import * as localServices from "./../../services/local";
import toast, { Toaster } from "react-hot-toast";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import PersonalInfoForm from "./personal_Info_form";
import PaymentInfoForm from "./persnal_payment_form";
import { useNavigate, useSearchParams } from "react-router-dom";

const CustomerForm = () => {
  const [searchParams] = useSearchParams();
  const customer_id = searchParams.get("customer_id");

  const [group, setGroup] = useState("");
  const [personType, setPersonType] = useState("normal");

  const [cars, setCars] = useState([]); // { type, license, province }
  const [drivers, setDrivers] = useState([]); // { name, surname, idCard }
  const [originalCitizenId, setOriginalCitizenId] = useState("");

  const [tabIndex, setTabIndex] = useState(0);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    citizenId: "",
    phone: "",
    address: "",
    img: "",
    dob: "",
    // server อาจมีฟิลด์อื่น ๆ ติดมาด้วย แต่เราจะ clean ตอน submit
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (!customer_id) {
      toast.error("ไม่พบ customer_id");
      return;
    }
    loadInitial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer_id]);

  const loadInitial = async () => {
    try {
      // โหลดกลุ่ม
      const resGroups = await services.getGroup();
      const raw = resGroups?.data?.data ?? [];
      setCustomerGroups(raw.map((g) => ({ id: g.id, name: g.name || "-" })));

      // โหลดข้อมูลลูกค้า
      const resCus = await services.getCustomersById(customer_id);
      const c = resCus?.data?.data;
      if (!c) throw new Error("ไม่พบข้อมูลลูกค้า");
      // set form + state
      setFormData({
        name: c.name ?? "",
        citizenId: c.citizenId ?? "",
        phone: c.phone ?? "",
        address: c.address ?? "",
        img: c.img ?? "",
        dob: c.dob ?? "",
        personType: c.personType ?? "normal",
        customerType: c.customerType ?? "SELLER",
        shopId: c.shopId,
        branchId: c.branchId,
        bankAccountName: c.bankAccountName,
        bankAccountNumber: c.bankAccountNumber,
        bankBranch: c.bankBranch,
        bankName: c.bankName,
        purchaseTaxOption: c.purchaseTaxOption,
        roundingOption: c.roundingOption,
        salesTaxOption: c.salesTaxOption,
      });

      setOriginalCitizenId(c.citizenId ?? "");
      setPersonType(c.personType ?? "normal");
      setGroup(c.customerGroupId);
      setCars(Array.isArray(c.cars) ? c.cars.map(normalizeCar) : []);
      setDrivers(
        Array.isArray(c.drivers) ? c.drivers.map(normalizeDriver) : []
      );
    } catch (e) {
      console.error("loadInitial error:", e);
      toast.error(e?.message ?? "โหลดข้อมูลล้มเหลว");
    }
  };

  // =========== Utils ===========
  const normalizeCar = (car) => ({
    type: car?.type ?? "",
    license: car?.license ?? "",
    province: car?.province ?? "",
  });

  const normalizeDriver = (d) => ({
    name: d?.name ?? "",
    surname: d?.surname ?? d?.suername ?? "", // กันเคสสะกดเดิม
    idCard: d?.idCard ?? "",
  });

  const isBase64 = (str) =>
    typeof str === "string" && /^data:image\/[a-zA-Z]+;base64,/.test(str);

  const base64ToBlob = (base64, mimeType = "image/png") => {
    const byteString = atob(base64.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ab], { type: mimeType });
  };

  // =========== Reader ===========
  const readCard = async () => {
    try {
      const res = await localServices.readCard();
      const data = res.data.data;
      setFormData((prev) => ({
        ...prev,
        name: `${data.firstNameTH} ${data.lastNameTH}`,
        dob: data.birthday,
        citizenId: data.citizenId,
        address: data.address,
        img: data.photo,
      }));
    } catch (err) {
      console.error("readCard err:", err);
      alert("ไม่สามารถอ่านบัตรได้");
    }
  };

  // =========== Form handlers ===========
  const handleChange = (field) => (event) => {
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleTabChange = (_, newValue) => setTabIndex(newValue);

  // Cars
  const handleAddCar = (car) => {
    if (car && typeof car === "object") {
      setCars((prev) => [...prev, normalizeCar(car)]);
    } else {
      setCars((prev) => [...prev, { type: "", license: "", province: "" }]);
    }
  };
  const handleDeleteCar = (index) => {
    setCars((prev) => prev.filter((_, i) => i !== index));
  };
  const handleCarChange = (index, field, value) => {
    setCars((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  // Drivers
  const handleAddDriver = (driver) => {
    if (driver && typeof driver === "object") {
      setDrivers((prev) => [...prev, normalizeDriver(driver)]);
    } else {
      setDrivers((prev) => [...prev, { name: "", surname: "", idCard: "" }]);
    }
  };
  const handleDeleteDriver = (index) => {
    setDrivers((prev) => prev.filter((_, i) => i !== index));
  };
  const handleDriverChange = (index, field, value) => {
    setDrivers((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  // =========== Submit ===========
  const handleSubmit = async () => {
    try {
      let imgToSend = formData.img ?? "";

      // อัปโหลดรูปเมื่อเป็น base64
      if (imgToSend && isBase64(imgToSend)) {
        const blob = base64ToBlob(imgToSend);
        const form = new FormData();
        form.append("file", blob, "image.png");
        const response = await services.upload(form);
        imgToSend = response?.data?.file ?? "";
      }

      // clean ฟิลด์ที่ไม่ควรส่งกลับ (เหลือแต่ที่แก้ได้)
      // NOTE: ถ้า formData ดึงมาทั้งก้อนจาก server จะมี id/createdAt/updatedAt เป็นต้น
      const {
        id,
        createdAt,
        updatedAt,
        deletedAt,
        userId,
        user,
        cars: _cars,
        drivers: _drivers,
        customerGroup, // relation object
        ...clean
      } = formData;

      // แปลง null -> undefined (Elysia schema จะชอบ undefined มากกว่า null)
      const scrubNulls = (obj) =>
        Object.fromEntries(
          Object.entries(obj).map(([k, v]) => [k, v === null ? undefined : v])
        );

      const payload = scrubNulls({
        ...clean,
        img: imgToSend,
        personType,
        customerGroupId: group,
        cars,
        drivers,
      });

      delete payload.shopId;
      delete payload.branchId;
      delete payload.customerType;
      if ((payload.citizenId || "").trim() === (originalCitizenId || "").trim()) {
        delete payload.citizenId;
      }

      await services.updateCustomer(payload, customer_id, { includeMeta: false });
      toast.success("แก้ไขรายการสำเร็จ!");
      // รีโหลดข้อมูลเพื่อ sync state ล่าสุด (หรือจะ navigate กลับ list ก็ได้)
      await loadInitial();
    } catch (err) {
      console.error("update error:", err);
      const msg =
        err?.response?.data?.error ?? err?.message ?? "แก้ไขรายการไม่สำเร็จ!";
      toast.error(msg);
    }
  };

  return (
    <div className="h-[calc(100vh-64px)] bg-gray-50 flex flex-col overflow-y-auto w-full">
      <div className="max-w-5xl mx-auto w-full p-4 md:p-8 pb-20">
         <AppBreadcrumbs />
         <Toaster position="bottom-right" reverseOrder={false} />

         <div className="mt-6 bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
             {/* Header/Tabs */}
             <div className="border-b border-gray-100 bg-gray-50/50 p-1">
                <div className="flex p-1 bg-gray-200/50 rounded-xl w-max mx-auto md:mx-0 md:w-full md:max-w-md">
                   <button
                     onClick={() => handleTabChange(null, 0)}
                     className={`flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                       tabIndex === 0
                         ? "bg-white text-gray-800 shadow-sm"
                         : "text-gray-500 hover:text-gray-700 hover:bg-gray-200/50"
                     }`}
                   >
                     ข้อมูลส่วนตัว
                   </button>
                   <button
                     onClick={() => handleTabChange(null, 1)}
                     className={`flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                       tabIndex === 1
                         ? "bg-white text-gray-800 shadow-sm"
                         : "text-gray-500 hover:text-gray-700 hover:bg-gray-200/50"
                     }`}
                   >
                     การชำระเงิน
                   </button>
                </div>
             </div>

             <div className="p-6 md:p-8">
                {tabIndex === 0 && (
                   <div className="animate-fade-in">
                      <PersonalInfoForm
                        formData={formData}
                        handleChange={handleChange}
                        readCard={readCard}
                        customerGroups={customerGroups}
                        group={group}
                        setGroup={setGroup}
                        personType={personType}
                        setPersonType={setPersonType}
                        cars={cars}
                        drivers={drivers}
                        handleAddCar={handleAddCar}
                        handleAddDriver={handleAddDriver}
                        handleDeleteCar={handleDeleteCar}
                        handleDeleteDriver={handleDeleteDriver}
                        handleCarChange={handleCarChange}
                        handleDriverChange={handleDriverChange}
                      />
                   </div>
                )}

                {tabIndex === 1 && (
                   <div className="animate-fade-in">
                      <PaymentInfoForm
                        formData={formData}
                        handleChange={handleChange}
                        readCard={readCard}
                        customerGroups={customerGroups}
                        group={group}
                        setGroup={setGroup}
                        personType={personType}
                        setPersonType={setPersonType}
                        cars={cars}
                        handleAddCar={handleAddCar}
                        handleDeleteCar={handleDeleteCar}
                        handleCarChange={handleCarChange}
                        handleDriverChange={handleDriverChange}
                        handleDriverChang={handleDriverChange}
                      />
                   </div>
                )}

                <div className="mt-8 pt-6 border-t border-gray-100 flex justify-center md:justify-end gap-3">
                   <button 
                      onClick={() => navigate(-1)}
                      className="px-6 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 active:bg-gray-100 transition-colors"
                    >
                      ย้อนกลับ
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="px-8 py-2.5 rounded-xl bg-gradient-to-br from-[#10B981] to-[#059669] text-white font-medium shadow-lg shadow-green-200 hover:shadow-green-300 hover:translate-y-[-1px] active:translate-y-[0px] transition-all"
                    >
                      บันทึกข้อมูล
                    </button>
                </div>
             </div>
         </div>
      </div>
    </div>
  );
};

export default CustomerForm;
